import { Component, OnInit } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from "@angular/router";

import { ComponentBase, DialogService } from "@definitiv-packages/angular-dba-library";
import { CompletedFormDialogComponent, CompletedFormDialogData } from "@definitiv-packages/angular-forms-library";

import {ProjectLanguage, ObjektViewService,TodoViewService,SafetyPointFormModelViewService,SafetyPointViewService, TodoService,TodoModelView, TodoModel,SafetyPointFormModelView, AppService,ObjektModelView, SafetyPointModelView } from "../../../../../roofsafetymanagement-library/src/public-api";

@Component({
    selector: 'lib-todos-view',
    templateUrl: './todos-view.component.html',
    styleUrls: ['./todos-view.component.scss'],
    standalone: false
})
export class TodosViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {

    public TodosList: TodoModelView[] = [];
    public SafetypointFormList: SafetyPointFormModelView[]=[];
    public documentList: Document[] = [];
    public safetyPointList: SafetyPointModelView[] = [];
    public objektList: ObjektModelView[] = [];
    public FilterListe: filterOption[] = [];
    public selectedFilter: filterOption = new filterOption();

    constructor(
        private todoViewService: TodoViewService,
        private TodoService: TodoService,
        public dialogService: DialogService,
        private safetyPointService: SafetyPointViewService,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private appService: AppService,
        private safetyPointFormModelViewService: SafetyPointFormModelViewService,
        private objektViewService: ObjektViewService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        
        this.loadData();
    }

    public async loadData() {
        this.loading = true;
        var resultList = await Promise.all([
            this.todoViewService.getList(),   
            this.safetyPointFormModelViewService.getList(),
            this.safetyPointService.getList(),
            this.objektViewService.getList()
        ])
        
        this.TodosList = resultList[0].sort((a,b)=>{
            return (a.Termin<b.Termin)?-1:1
        })
        this.objektList = resultList[3];
        const objIDs = this.objektList.filter(x=>x.SafetyPointCount == 0).map(y=>y.ObjektID);        
        this.TodosList = this.TodosList.filter(x=>!objIDs.includes(x.ObjektId));

        this.SafetypointFormList = resultList[1];
        this.safetyPointList = resultList[2];
        
        this.loading = false;
    }

    public navigateToObjectService(toDo: TodoModelView): void {
        this.router.navigate(['/object-service/', toDo.ObjektId],{ queryParams: { todoId: toDo.TodoId }} );
    }

    public todoErledigen(todo: TodoModelView) {
        var dat = new CompletedFormDialogData(todo.FormId);

        this.dialog.open(CompletedFormDialogComponent, { data: dat }).afterClosed().subscribe(res => {
            if (res) {

                todo.CompletedFormId = 1;
                todo.ErledigtVonId = this.appService.CurrentUser?.UserID!
                todo.ErledigtAm = new Date();
                todo.Bemerkung = null;
                this.TodoService.put(todo.TodoId, todo as TodoModel)
            }
        })
    }
    public todoStornieren(todo: TodoModelView) {
        this.dialogService.showInputDialog(this.languageService.getText(this.language.TodoStornieren), '', this.languageService.getText(this.language.BitteBegruendungEigeben)).subscribe(res => {
            if (res) {

                todo.CompletedFormId = 1;
                todo.ErledigtVonId = this.appService.CurrentUser?.UserID!
                todo.ErledigtAm = new Date();
                todo.Bemerkung = res;              
                this.TodoService.put(todo.TodoId, todo as TodoModel)
       
            }
        })
    }

    public filteredTodos() {
        if (this.selectedFilter.ID == "1") {
            return this.TodosList.filter(x => x.ErledigtAm != null && x.Bemerkung == null);
        }

        if (this.selectedFilter.ID == "2") {
            return this.TodosList.filter(x => x.ErledigtAm != null && x.Bemerkung == null);
        }
        return this.TodosList;
    }

  getObjektistErledigt(todo: TodoModelView):boolean{
       
      if(!todo) return false;
      var object = this.objektList.find(x=>x.ObjektID == todo.ObjektId);
      if(!object) return false;
      return this.SafetypointFormList.filter(x=>x.ObjektID == object!.ObjektID && x.TodoId == todo.TodoId).length == this.safetyPointList.filter(x=>x.ObjektID==object!.ObjektID).length &&
      this.safetyPointList.filter(x=>x.ObjektID==object!.ObjektID).length>0;
  }    
}
export class filterOption {
    public ID: string = "";
    public Label: string = "";
}
